require('./bootstrap');
require('slick-carousel');
require('./dialog_trigger');

window.hitback = function (link){
   window.open(link, '_blank');				
}

 window.externallink = function(link,category,label){
    gtag('event','click', {
        'event_category': category,
        'event_label': label,
        'transport_type': 'beacon',
        'event_callback': hitback(link),
    });

	return false;
}

$( document ).ready(function() {
   $.ajaxSetup({
          headers: {
              'X-CSRF-TOKEN': $('meta[name="csrf-token"]').attr('content')
          }
   });


  $('body').on('click', 'a.select_item_btn_ga_event',function(){
      var item = $(this).data('item');
      if(item)
          window.selectItem(item);
      
  });


  if($('#mobile-tabs').length > 0){

       if($('#faqs-section').length > 0){
        $('#mobile-tabs').find('.col-for-faqs-tab').removeClass('d-none');
        $('#mobile-tabs').on('click','#faqs-tab',function(e){
            e.preventDefault();
            if($(this).closest('.nav').hasClass('active')){
              $('#mobile-tabs').find('.active').removeClass('active');
              $('#series-description').find('#test-progress-section').hide();
              $('#series-description').find('#series-content-holder').hide();
              $('#faqs-section').find('#faqs-content-holder').hide();
            }else{

              $('#mobile-tabs').find('.active').removeClass('active');
              $('#series-description').find('#test-progress-section').hide();
              $('#series-description').find('#series-content-holder').hide();
              $('#faqs-section').find('#faqs-content-holder').fadeIn(400);
              $(this).closest('.nav').addClass('active');
            }

            return false;
        })

      }

      if($('#series-description').length > 0){
        $('#mobile-tabs').find('.col-for-instructions-tab').removeClass('d-none');
        $('#mobile-tabs').on('click','#instructions-tab',function(e){
            e.preventDefault();
            if($(this).closest('.nav').hasClass('active')){
              $('#mobile-tabs').find('.active').removeClass('active');
              $('#series-description').find('#test-progress-section').hide();
              $('#series-description').find('#series-content-holder').hide();
              $('#faqs-section').find('#faqs-content-holder').hide();
            }else{
              $('#mobile-tabs').find('.active').removeClass('active');
              $('#series-description').find('#test-progress-section').hide();
              $('#faqs-section').find('#faqs-content-holder').hide();
              $('#series-description').find('#series-content-holder').fadeIn(400);
              $(this).closest('.nav').addClass('active');
            }

            return false;
        })

      }

      if($('#test-progress').length > 0 && !$('#test-progress').hasClass('d-none')){
        $('#mobile-tabs').find('.col-for-test-progress-tab').removeClass('d-none');
        $('#mobile-tabs').on('click','#test-progress-tab',function(e){
            e.preventDefault();
            if($(this).closest('.nav').hasClass('active')){
              $('#mobile-tabs').find('.active').removeClass('active');
              $('#series-description').find('#test-progress-section').hide();
              $('#series-description').find('#series-content-holder').hide();
              $('#faqs-section').find('#faqs-content-holder').hide();
            }else{
              $('#mobile-tabs').find('.active').removeClass('active');
              $('#series-description').find('#series-content-holder').hide();
              $('#faqs-section').find('#faqs-content-holder').hide();
              $('#series-description').find('#test-progress-section').fadeIn(400);
              $(this).closest('.nav').addClass('active');
            }
            return false;
        })

      }
  
  }


	$('#homepage-states').on('click', function (e) {

	  var id = $(this).data('id');
	  $('#'+id).dropdown('toggle');
	  return false;
	});

  if($('#side-google').length > 0){
    setTimeout(function() {
        if($('#side-google').children().eq(0).is(':visible') && $('#side-google').children().eq(0).height() > 0 ){

        }else{
          $('#side-google').css({'min-height':'0px'}); 
        }

    }, 3000);
  }

  if($('#video-google').length > 0){
    setTimeout(function() {
        if($('#video-google').children().eq(0).is(':visible') && $('#video-google').children().eq(0).height() > 0 ){

        }else{
          $('#video-google').css({'min-height':'0px'}); 
        }

    }, 3000);
  }

  if($('#video-google-mobile').length > 0){
    setTimeout(function() {
        if($('#video-google-mobile').children().eq(0).is(':visible') && $('#video-google-mobile').children().eq(0).height() > 0 ){

        }else{
          $('#video-google-mobile').css({'min-height':'0px'}); 
        }

    }, 3000);
  }

  if($('#top-google').length > 0){
    setTimeout(function() {
        if($('#top-google').children().eq(0).is(':visible') && $('#top-google').children().eq(0).height() > 0 ){

        }else{
          $('#top-google').css({'min-height':'0px'}); 
        }

    }, 3000);
  }

  if($('#bottom-google').length > 0){
    setTimeout(function() {
        if($('#bottom-google').children().eq(0).is(':visible') && $('#bottom-google').children().eq(0).height() > 0 ){

        }else{
          $('#bottom-google').css({'min-height':'0px'}); 
        }

    }, 3000);
  }


  $('#go-to-top').on('click',function(e){ 
      e.preventDefault();
      $(window.opera ? 'html' : 'html, body').animate({
          scrollTop: 0
      }, 'slow');
      return false;
  });


  if($('.series-description').length > 0){
    $('.series-description').on('click','a.view-more-button', function (e) {
        e.preventDefault();
        var descriptionHolder = $(this).closest('.series-description');

        $(this).hide();
        $(descriptionHolder).find('.description-teaser').hide();
        $(descriptionHolder).find('.description-full-description').show();
       

        return false;
    })
  }


	$('.radio-btn-holder').on('click','input',function(){
		var closestHolder = $(this).closest('.radio-btn-holder'),
			topHolder = $(closestHolder).closest('.answer-pick-holder');


			$(topHolder).find('input').prop('checked',false);
      $(topHolder).find('.user-selected').removeClass('user-selected');
			$(closestHolder).addClass('user-selected');			
      $(this).prop('checked',true).trigger('change');

	});

  $('.search-btn-holder').on('click','input',function(){
    var closestHolder = $(this).closest('.button-item '),
      topHolder = $(closestHolder).closest('.columns-blocks');


      $(topHolder).find('.active').removeClass('active');
      $(closestHolder).addClass('active');     

  });


	$('#question-form').on('click','a#next-section',function(e){
      if($(this).hasClass('isClicked')){
        var btnClicked = $(this);
        setTimeout(function() {
          $(btnClicked).removeClass('isClicked');
        }, 200);
        return false;
      }
      if($(this).hasClass('has-validation')){
     		e.preventDefault();
          var btnClicked = $(this);

         	$(this).closest('#question-form').addClass('validated');
          $(this).addClass('isClicked').removeClass('has-validation');
          var urlToPost = $(this).data('page');
     		  $.validateAnswers(urlToPost);   	

          setTimeout(function() {
            $(btnClicked).removeClass('isClicked');
          }, 600);	

     		return false;
      }

	});


  if($('#test-progress-section').length > 0){
    $('#test-progress-section').on('click','#progress-test',function(e){
        e.preventDefault();
        if($(window).width() < 991){
          if($(this).hasClass('opened')){
              $('#test-progress-section').find('#test-progress-holder').removeClass('opened')
              $(this).removeClass('opened');
          }else{
              $('#test-progress-section').find('#test-progress-holder').addClass('opened')
              $(this).addClass('opened');
          }

        }

        return false;
    })

  }

  if($('#go-back-holder').length > 0){
      var goBack = new IntersectionObserver(function(entries) {

        if($(document).scrollTop() < 120){
            document.querySelector("#go-back-holder").classList.remove("sticky-full");
        }else{
            // no intersection with screen
            if(entries[0].intersectionRatio === 0){
               document.querySelector("#go-back-holder").classList.add("sticky-full");
            }
            // fully intersects with screen
            else if(entries[0].intersectionRatio === 1){
               document.querySelector("#go-back-holder").classList.remove("sticky-full");
            }
        }
      }, { threshold: [0,1] });

     goBack.observe(document.querySelector('#sticky-holder'));
  }

  
  if($('#searchDropdownInline').length > 0){

    $(document).on('click',function(e) 
    {

          var sitemapFilter = $("#searchDropdownMenuHolder");
          if (!sitemapFilter.is(e.target) && sitemapFilter.has(e.target).length === 0) 
          {
              $('#searchDropdownResults').empty();
              $('#searchDropdownMenuHolder').removeClass('show');
              $('#searchDropdownMenu').removeClass('show');
              $('.fullBodyOverlay').removeClass('showed');
          }

         

    });


      $('#searchDropdownInline').on('click', function (e) {
        // console.log($(this));

        $('#searchDropdownMenuHolder').addClass('show');
        $('#searchDropdownMenu').addClass('show');
        $('.fullBodyOverlay').addClass('showed');
        return false;
      })


      var searchFormFilter = false;
      $('#searchDropdownMenuHolder').on('keyup','#search-input' ,function(e){         
        var value = $(this).val();
        var type = $(this).next().val()
        if(value && type){
            clearTimeout(searchFormFilter);

            if( value.length < 3 ){
              $('#searchDropdownResults').empty();
              
              return; 
            } 

            searchFormFilter = setTimeout(function () {
                $.filter_sitemap_search(value,type,'#searchDropdownResults');                    

            }, 600);
        }
            
        return false;

      }).on('focus','input#search-input' ,function(e){         
        e.preventDefault();

        var value = $(this).val();
        var type = $(this).next().val();
        if(value && type){
            if( value.length > 3 ){
                clearTimeout(searchFormFilter);
                searchFormFilter = setTimeout(function () {
                    $.filter_sitemap_search(value,type,'#searchDropdownResults')
                }, 100);

            }                 
        }

      });
  }





  if($('#pop-up-show').length > 0)
      $.exitIntent('#pop-up-show');

  if($('#result-validation').length > 0){
    if($('#result-validation').hasClass('sticky-full')){


    }else{
      var initObserver = new IntersectionObserver(function(entries) {

          if($(document).scrollTop() < 120){
              document.querySelector("#result-validation").classList.remove("sticky-full");
          }else{
              // no intersection with screen
              if(entries[0].intersectionRatio === 0){
                 document.querySelector("#result-validation").classList.add("sticky-full");
              }
              // fully intersects with screen
              else if(entries[0].intersectionRatio === 1){
                 document.querySelector("#result-validation").classList.remove("sticky-full");
              }
          }
       }, { threshold: [0,1] });

       initObserver.observe(document.querySelector('#sticky-holder'));

    }
  }

  if($('#banner-app-footer').length > 0 && $(window).width() < 768){

      var initBannerObserver = new IntersectionObserver(function(entries) {

          if($(document).scrollTop() < 120){
              document.querySelector("#banner-app-footer").classList.remove("sticky-full");
          }else{
              // no intersection with screen
              if(entries[0].intersectionRatio === 0){
                 document.querySelector("#banner-app-footer").classList.add("sticky-full");
              }
              // fully intersects with screen
              else if(entries[0].intersectionRatio === 1){
                 document.querySelector("#banner-app-footer").classList.remove("sticky-full");
              }
          }
       }, { threshold: [0,1] });

       initBannerObserver.observe(document.querySelector('#sticky-holder'));    
  }
  if($('#download-app-stores').length > 0 && $(window).width() < 768){
    if($('#sticky-holder').length > 0){
      var initBannerObserver = new IntersectionObserver(function(entries) {

          if($(document).scrollTop() < 120){
              document.querySelector("#download-app-stores").classList.remove("sticky-full");
          }else{
              // no intersection with screen
              if(entries[0].intersectionRatio === 0){
                 document.querySelector("#download-app-stores").classList.add("sticky-full");
              }
              // fully intersects with screen
              else if(entries[0].intersectionRatio === 1){
                 document.querySelector("#download-app-stores").classList.remove("sticky-full");
              }
          }
       }, { threshold: [0,1] });

       initBannerObserver.observe(document.querySelector('#sticky-holder'));    
    }
  }

  if($('#download-app-footer').length > 0 && $(window).width() < 768){

      var initBannerObserver = new IntersectionObserver(function(entries) {

          if($(document).scrollTop() < 120){
              document.querySelector("#download-app-footer").classList.remove("sticky-full");
          }else{
              // no intersection with screen
              if(entries[0].intersectionRatio === 0){
                 document.querySelector("#download-app-footer").classList.add("sticky-full");
              }
              // fully intersects with screen
              else if(entries[0].intersectionRatio === 1){
                 document.querySelector("#download-app-footer").classList.remove("sticky-full");
              }
          }
       }, { threshold: [0,1] });

       initBannerObserver.observe(document.querySelector('#sticky-holder'));    
  }


  if($('#question-form').length > 0 && $(window).width() < 768){

      var initButtonNextObserver = new IntersectionObserver(function(entries) {
          // no intersection with screen
          if($("#question-form").hasClass('validated')){
              document.querySelector("#question-form").classList.remove("sticky-full");
          }else{
            if(entries[0].intersectionRatio === 0){
               document.querySelector("#question-form").classList.remove("sticky-full");
            }
            // fully intersects with screen
            else if(entries[0].intersectionRatio > 0){
               document.querySelector("#question-form").classList.add("sticky-full");
            }
          }
          
       }, { threshold: [0,1] });

       initButtonNextObserver.observe(document.querySelector('#aside'));    
  }


  if($('.rating-holder').length > 0){

      $('.rating-holder').on('change','input.rb',function(){
          var stars = $(this).val(),
              state = $(this).closest('.rating-holder').data('state'),
              type = $(this).closest('.rating-holder').data('type');

              $.ajax({
                  async: true,
                  url: '/rate-us',
                  method:'post',
                  data: { 
                      state:state,
                      type:type,
                      stars: stars,                            
                  },
                  success: function(data) {
                      $('.rating-holder').find('input').prop('disabled',true);

                      if(data.status){      
                        $('.rating-holder').find('.star-text-holder p').hide();
                        $('.rating-holder').find('.star-text-holder p.ratting-success').show();
                      }else{
                          $('.rating-holder').find('.star-text-holder p').hide();
                          $('.rating-holder').find('.star-text-holder p.ratting-error').show();
                      }
                  },
                  error: function() { 
                      $('.rating-holder').find('input').prop('disabled',true);                
                      $('.rating-holder').find('.star-text-holder p').hide();
                      $('.rating-holder').find('.star-text-holder p.ratting-error').show();
                  }
              });



      });


  }

  if($('#question-section').length > 0){
      $('#question-section').on('click','a#showJuniorContentUp',function(e){
        e.preventDefault();
        if($(this).hasClass('clicked')){
            $(this).removeClass('clicked');
            $(this).closest('.readiness-description').find('p.slide-description').slideUp(400);
        }else{
            $(this).addClass('clicked');
            $(this).closest('.readiness-description').find('p.slide-description').slideDown(400);
        }

        return false;
      });

      $('#question-form').on('click','a#showJuniorContent',function(e){
        e.preventDefault();
        if($(this).hasClass('clicked')){
            $(this).removeClass('clicked');
            $(this).closest('.readiness-description').find('p.slide-description').slideUp(400);
        }else{
            $(this).addClass('clicked');
            $(this).closest('.readiness-description').find('p.slide-description').slideDown(400);
        }

        return false;
      });

      $('#question-section').on('click','a.special-case-choose',function(e){
        e.preventDefault();
        var $urlToPost = $(this).attr('href');
        var $urlToReplace = $(this).data('href');
          $.ajax({
           method: "post",
           url: $urlToPost,
           data: {'cookieSet': 1},
           success: function(response) {  
              // window.location.href = $urlToReplace;                 
              $('#junior-final').fadeOut(400);
              $('#junior-final-validation-box').fadeOut(400);
              $('#junior-final-next-box').removeClass('d-none');
              $('#question-form').find('.go-to-next-section').show();
           },
           error: function(response) {
              // window.location.href = $urlToReplace;                 
              $('#junior-final').fadeOut(400);
              $('#junior-final-validation-box').fadeOut(400);
              $('#junior-final-next-box').removeClass('d-none');
              $('#question-form').find('.go-to-next-section').show();
           }
        });

        return false;
      });

  }




  if ($('#samples-slider-carousel').length > 0) {

      var samplesSlick = $('#samples-slider-carousel').slick({
                          autoplay: true,
                          autoplaySpeed: 5000,
                          centerMode: false,
                          centerPadding: '0px',
                          slidesToShow: 3,
                          infinity: true,
                          nextArrow: '#sample-next',
                          prevArrow: '#sample-prev',
                          responsive: [
                              {
                                  breakpoint: 1140,
                                  settings: {
                                      autoplay: true,
                                      arrows: true,
                                      centerMode: false,
                                      centerPadding: '55px',
                                      slidesToShow: 2
                                  }
                              },
                              {
                              breakpoint: 990,
                                  settings: {
                                      autoplay: true,
                                      arrows: false,
                                      centerMode: false,
                                      centerPadding: '15px',
                                      slidesToShow: 2
                                  }
                              },
                              {
                              breakpoint: 782,
                                  settings: {
                                      autoplay: true,
                                      arrows: false,
                                      centerMode: false,
                                      centerPadding: '95px',
                                      slidesToShow: 2
                                  }
                              },
                              {
                              breakpoint: 700,
                                  settings: {
                                      autoplay: true,
                                      arrows: false,
                                      centerMode: true,
                                      centerPadding: '45px',
                                      slidesToShow: 1
                                  }
                              },
                              {
                                  breakpoint: 360,
                                  settings: {
                                      autoplay: true,
                                      arrows: false,
                                      centerMode: true,
                                      centerPadding: '25px',
                                      slidesToShow: 1
                                  }
                              },
                          ]
                      });





      var sampleImageShow = 0;
      $('#samples-slider-carousel').on('click', 'a.bootstrap-modal-show',function(e){
          e.preventDefault();
          $('#sample-modal').find('img').hide().removeClass('showed');
          sampleImageShow = $(this).data('image');

          if(sampleImageShow){
              $('#sample-modal').find('#sample-image-'+sampleImageShow).fadeIn(200).addClass('showed');
              $('#sample-modal').modal('show')
          }
          return false;
      })

      $('#sample-modal').on('click', 'a#sample-modal-prev',function(e){
          e.preventDefault();
          $('#sample-modal').find('img').hide().removeClass('showed');

          if(sampleImageShow == 1)
              sampleImageShow = 4;
          else
              sampleImageShow--;

          $('#sample-modal').find('#sample-image-'+sampleImageShow).fadeIn(200).addClass('showed');

          return false;
      })

      $('#sample-modal').on('click', 'a#sample-modal-next',function(e){
          e.preventDefault();
          $('#sample-modal').find('img').hide().removeClass('showed');
          if(sampleImageShow == 4)
              sampleImageShow = 1;
          else
              sampleImageShow++;

          $('#sample-modal').find('#sample-image-'+sampleImageShow).fadeIn(200).addClass('showed');

          return false;
      })

  }
  

});


$(function() {
      $('#bookmarkme').click(function() {
          if (window.sidebar && window.sidebar.addPanel) { // Mozilla Firefox Bookmark
              window.sidebar.addPanel(document.title,window.location.href,'');
          } else if(window.external && ('AddFavorite' in window.external)) { // IE Favorite
              window.external.AddFavorite(location.href,document.title); 
          } else if(window.opera && window.print) { // Opera Hotlist
              this.title=document.title;
              return true;
          } else { // webkit - safari/chrome
              alert('Press ' + (navigator.userAgent.toLowerCase().indexOf('mac') != - 1 ? 'Command/Cmd' : 'CTRL') + ' + D to bookmark this page.');
          }
          ga('send', 'event', 'button', 'click', 'bookmark');
      });
});


function getBodyScrollTop() {
    var el = document.scrollingElement || document.documentElement;
    return el.scrollTop;
}



// Search by ALL
$.filter_sitemap_search = function(value,type,$el = 'body'){

    var searchBy = {'q':value,'type':type};
    var url = $('#search-form').attr('action');

    if(url){
      $.ajax({
            method: "post",
            url: url,
            data: searchBy,
            success: function(data) {
                  if(data){
                     $($el).html(data);
                  }

                
                                     
            },
            error: function(data) {

                  // window.location.reload(true);
          }
      });
    }
   

}

$.exitIntent = function($el = '#pop-up-show'){

  var complete = false;
  if($(window).width() > 991){
      var dtExit = new window.DialogTrigger(function(){$($el).removeClass('exit_intent_scroll').addClass('exit_intent_out_page').addClass('showed').fadeIn(400); complete =  true; }, { trigger: 'exitIntent' });
  }

  var dtPercentDown = new window.DialogTrigger(function() {       
    var dtPercentUp = new window.DialogTrigger(function(){$($el).removeClass('exit_intent_out_page').addClass('exit_intent_scroll').addClass('showed').fadeIn(400); complete =  true; }, { trigger: 'scrollUp', percentUp: 15 });
  }, { trigger: 'scrollDown', percentDown: 35 });


  $($el).on('click','.close-exit-intent' ,function(e){
      e.preventDefault();
      $($el).removeClass('showed').fadeOut(400);
      $.ajax({
         method: "post",
         url: '/exit-intent',
         data: {'exitIntent': 0},
         success: function(response) {                   
            complete = true;       
         },
         error: function(response) {
            complete = true; 
         }
      });
      return false
  });

}
$.validateAnswers = function($urlToPost = false, $el = '#questions-holder', $responseHolder = '#test-progress-section'){

   	var questionsWrappers = $($el).find('.question-row'),
          answers = {},
          firstErrorWrapper = false, 
          firstError = false;

   	$.each(questionsWrappers,function(i,k){
   		$(k).addClass('validated');
   		$(k).find('.radio-btn-holder').removeClass('user-selected').addClass('disabled-selected not-related');
   		var answer = $(k).find('input:checked'),   			
   			questionNo = $(k).data('number'),
        questionHashId = $(k).data('hashid'),
        questionId = $(k).data('id'),
        option = $(k).data('option'),
   			questionRes = $(k).data('value'),            
   			inputHtml = '';

        if($(answer).length > 1)
          answer = $(k).find('input:checked').first();

   		var validInput = $(k).find('input[value="'+questionRes+'"]');

   		if($(answer).length > 0){
   			if($(answer).val() == questionRes){
            answers[questionNo] = {'status': 1, 'answer': $(answer).val(),  'option': option, 'hashId': questionHashId, 'id': questionId };   				
   				  $(answer).closest('.radio-btn-holder').removeClass('not-related').addClass('correct-selected');
   			}
   			else{
   				answers[questionNo] = {'status': 0, 'answer': $(answer).val(), 'option': option, 'hashId': questionHashId, 'id': questionId };
   				$(answer).closest('.radio-btn-holder').removeClass('not-related').addClass('error-selected');
          if (!firstErrorWrapper) firstErrorWrapper = $(k);
   			}

   		}else{
            answers[questionNo] = {'status': 0, 'answer': 0, 'option': option, 'hashId': questionHashId, 'id': questionId  };
            if (!firstErrorWrapper) firstErrorWrapper = $(k);
   		}

   		if($(validInput).length > 0){
   			$(validInput).closest('.radio-btn-holder').removeClass('not-related').addClass('correct-selected');
   		}

   	});

      setTimeout(function() {
         if($(answers).length > 0 && $urlToPost){
            $.ajax({
                   method: "post",
                   url: $urlToPost,
                   data: {'answer': answers},
                   success: function(response) {
                         if(response){
                            // if($("#top-google").length)
                            //   var scrollToId = '#top-google';
                            // else
                            //   var scrollToId = '#questions';

                              var scrollToId = '#test-progress-holder';

                           $($responseHolder).html(response).promise().done(function(){ 
                              if($($responseHolder).find('#result-validation').length > 0){
                                  $($responseHolder).find('#result-validation').prependTo($el).promise().done(function(){


                                      $('html, body').animate({
                                           scrollTop: $(scrollToId).offset().top - 60
                                      }, 1000, function() {

                                          if($('body').find('#result-validation').hasClass('sticky-full')){
                                          }else{
                                              var observer = new IntersectionObserver(function(entries) {

                                                  if($(document).scrollTop() < 120){
                                                      document.querySelector("#result-validation").classList.remove("sticky-full");
                                                  }else{
                                                      // no intersection with screen
                                                      if(entries[0].intersectionRatio === 0){
                                                         document.querySelector("#result-validation").classList.add("sticky-full");
                                                      }
                                                      // fully intersects with screen
                                                      else if(entries[0].intersectionRatio === 1){
                                                         document.querySelector("#result-validation").classList.remove("sticky-full");
                                                      }
                                                  }
                                               }, { threshold: [0,1] });

                                               observer.observe(document.querySelector('#sticky-holder'));
                                          }
                                      });
                                  });    

                              }else if($($responseHolder).find('#result-final').length > 0){

                                  $($responseHolder).find('#result-final').prependTo($el).promise().done(function(){
                                      $('html, body').animate({
                                           scrollTop: $(scrollToId).offset().top - 60
                                      }, 1000, function() {
                                              
                                      });
                                  }); 

                                  if($($responseHolder).find('#result-final-validation').length > 0){
                                      $($responseHolder).find('#result-final-validation').prependTo($el).promise().done(function(){

                                          $.updateStatistics($urlToPost); 

                                          $('html, body').animate({
                                               scrollTop: $(scrollToId).offset().top - 60
                                          }, 1000, function() {

                                              if($('body').find('#result-final-validation').hasClass('sticky-full')){

                                              }else{
                                                    var observer = new IntersectionObserver(function(entries) {

                                                    if($(document).scrollTop() < 120){
                                                        document.querySelector("#result-final-validation").classList.remove("sticky-full");
                                                    }else{
                                                        // no intersection with screen
                                                        if(entries[0].intersectionRatio === 0){
                                                           document.querySelector("#result-final-validation").classList.add("sticky-full");
                                                        }
                                                        // fully intersects with screen
                                                        else if(entries[0].intersectionRatio === 1){
                                                           document.querySelector("#result-final-validation").classList.remove("sticky-full");
                                                        }
                                                    }
                                                 }, { threshold: [0,1] });

                                                 observer.observe(document.querySelector('#sticky-holder'));
                                              }
                                          });
                                      });    

                                  }

                              }

                              if($($responseHolder).find('#junior-final').length > 0){
                                  $($responseHolder).find('#junior-final').prependTo($('#question-form')).promise().done(function(){
                                      $('#question-form').find('.go-to-next-section').hide();
                                  });    

                              }


                              if (!firstError && $(firstErrorWrapper).length) {
                                  firstError = true;
                                  $($('#study-tip-banner-holder').find('#study-tip-banner')).appendTo($(firstErrorWrapper)).promise().done(function () {
                                      if ($('#study-tip-slider-carousel').length > 0) {

                                          setTimeout(function () {

                                              var studyTipSlick = $('#study-tip-slider-carousel').slick({
                                                                  autoplay: true,
                                                                  autoplaySpeed: 5000,
                                                                  centerMode: false,
                                                                  centerPadding: '0px',
                                                                  slidesToShow: 3,
                                                                  infinity: true,
                                                                  nextArrow: '#study-tip-next',
                                                                  prevArrow: '#study-tip-prev',
                                                                  arrows: true                                                                      
                                                              });


                                              var item = $('#study-tip-banner-holder').find('#study-tip-banner a#ext_aff_dcs').data('item');
                                              if(item)
                                                  window.viewItemList(item);

                                              var studyTipImageShow = 0;
                                              $('#study-tip-slider-carousel').on('click', 'a.bootstrap-modal-show',function(e){
                                                  e.preventDefault();
                                                  $('#study-tip-modal').find('img').hide().removeClass('showed');
                                                  studyTipImageShow = $(this).data('image');

                                                  if(studyTipImageShow){
                                                      $('#study-tip-modal').find('#study-tip-image-'+studyTipImageShow).fadeIn(200).addClass('showed');
                                                      $('#study-tip-modal').modal('show')
                                                  }
                                                  return false;
                                              })

                                              $('#study-tip-modal').on('click', 'a#study-tip-modal-prev',function(e){
                                                  e.preventDefault();
                                                  $('#study-tip-modal').find('img').hide().removeClass('showed');

                                                  if(studyTipImageShow == 1)
                                                      studyTipImageShow = 4;
                                                  else
                                                      studyTipImageShow--;

                                                  $('#study-tip-modal').find('#study-tip-image-'+studyTipImageShow).fadeIn(200).addClass('showed');

                                                  return false;
                                              })

                                              $('#study-tip-modal').on('click', 'a#study-tip-modal-next',function(e){
                                                  e.preventDefault();
                                                  $('#study-tip-modal').find('img').hide().removeClass('showed');
                                                  if(studyTipImageShow == 4)
                                                      studyTipImageShow = 1;
                                                  else
                                                      studyTipImageShow++;

                                                  $('#study-tip-modal').find('#study-tip-image-'+studyTipImageShow).fadeIn(200).addClass('showed');

                                                  return false;
                                              })

                                          }, 400);

                                      }

                                  });                                


                              }


                              
                           });                            
                         }                      
                             
                   },
                   error: function(response) {
                        // window.location.reload(true);
                 }
            });
         }else{
            window.location.reload(true);
         }
      }, 100);

     
}



$.updateStatistics = function($urlToPost = false){

  $.ajax({
    url : $urlToPost,
    data : {},
    type : 'PATCH',
    contentType : 'application/json',
    processData: false,
    dataType: 'json',
    success: function(response) {

    },
    error: function(response) {
        // window.location.reload(true);
    }
  });

}

